import { motion, AnimatePresence } from 'framer-motion';

const GlobalLoader = ({ isLoading }) => {
  return (
    <AnimatePresence>
      {isLoading && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.2 }}
          className="fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-white"
        >
          <div className="flex flex-col items-center gap-6">
            {/* Logo */}
            <div className="text-2xl font-extrabold text-[#ff6900] tracking-widest" style={{ fontFamily: 'Georgia, serif' }}>
              WISECART
            </div>

            {/* Shopee-style sliding bar */}
            <div className="w-36 h-[3px] bg-orange-100 rounded-full overflow-hidden">
              <motion.div
                className="h-full bg-[#ff6900] rounded-full"
                initial={{ x: '-100%', width: '45%' }}
                animate={{ x: '250%' }}
                transition={{ duration: 1, ease: 'easeInOut', repeat: Infinity }}
              />
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default GlobalLoader;